export default __webpack_public_path__ + "static/OGimage-c4afdca5f9fc1990d40b6cfee6dc0bb5.webp";